module.exports = __webpack_public_path__ + "ea8c4fc08c2fc9cec8bdd2691ca7d305.svg";